<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="250px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="date"
        :label="label"
        hide-details
        dense
        class="filter-date ml-3"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
export default {
  props: ["value", "label"],
  data() {
    return {
      rules: [v => !!v || "Field is required"],
      date: moment().format("YYYY-MM-DD"),
      menu: false
    };
  },
  watch: {
    date(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.date = this.value;
  }
};
</script>

<style>
.filter-date {
  max-width: 150px;
}
</style>
